import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import CollectionNotificationList from '@/components/collection-notification/list'
import MunicipalityPermissionGate from '@/components/municipality-permission-gate'

function CollectionNotificationmanagementView() {

    const title = 'Správa upozornění ke svozu'

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper>
                <Typography variant="h2" component="h1" gutterBottom>
                    {title}
                </Typography>
                <MunicipalityPermissionGate>
                    <CollectionNotificationList editable={true} />
                </MunicipalityPermissionGate>
            </CustomPaper>
        </>
    )
}

export default CollectionNotificationmanagementView
